import { useCallback } from 'react';
import { useWatch } from 'react-hook-form';
import { DocumentBuilderForm } from '~/types/document-builder';
import { lineGrossTotals, lineNetTotals } from '~/utils/invoicing/items';

export const useLineTotals = () => {
  const useGrossPrices = useWatch<DocumentBuilderForm, 'useGrossPrices'>({ name: 'useGrossPrices' });

  return useCallback(
    (data: DocumentBuilderForm['items'][number]) => {
      return useGrossPrices ? lineGrossTotals(data) : lineNetTotals(data);
    },
    [useGrossPrices],
  );
};
